<template>
  <el-form
      ref="siaForm"
      :model="siaInfoObj"
      :rules="rules"
      label-position="top"
      label-width="100%"
      class="sia-questionnaire-form"
  >
    <el-card class="mb-4">
      <h3 class="text-center">SIA Questionnaire</h3>
      <h5 class="text-center bg-grey" v-if="isMarked">
        Percentage: {{ percentage }}% &nbsp;&nbsp; Result: {{ result }}
      </h5>
    </el-card>

    <el-form-item
        label="1. What do you call the Private Security Industry’s Governing Body?"
        prop="question_1"
        required
    >
      <el-radio-group v-model="siaInfoObj.question_1">
        <el-radio
            v-for="item in CallThePrivateSecurityIndustryGoverningBody"
            :key="item.id"
            :label="item.id"
            :class="getRadioStatusClass('question_1', item.id)"
            @change="handleChange('question_1')"
        >
          {{ item.value }}
        </el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item
        v-for="(meta, index) in questionsMeta"
        :key="`question_${index + 2}`"
        :label="`${index + 2}. ${meta.label}`"
        :prop="`question_${index + 2}`"
        required
    >
      <el-radio-group v-model="siaInfoObj[`question_${index + 2}`]">
        <el-radio
            v-for="item in meta.options"
            :key="item.id"
            :label="item.id"
            :class="getRadioStatusClass(`question_${index + 2}`, item.id)"
            @change="handleChange(`question_${index + 2}`)"
        >
          {{ item.value }}
        </el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "SIADetailInfo",
  props: {
    preloader: { type: Boolean, default: false },
    sia_Info: { type: Array, required: true },
    isAdmin: { type: Boolean, default: false }
  },
  data() {
    return {
      isMarked: false,
      correct: 0,
      wrong: 0,
      total: 0,
      siaInfoObj: {},
      CallThePrivateSecurityIndustryGoverningBody: [
        { id: "a", value: "(a) SIA" },
        { id: "b", value: "(b) PSC" },
        { id: "c", value: "(c) SIB" },
        { id: "d", value: "(d) PSI" },
      ],
      LicenseAbleActivitiesWithoutYourSIALicenseBadge: [
        { id: "a", value: "(a) Yes, if you have a valid license" },
        { id: "b", value: "(b) No, never" },
        { id: "c", value: "(c) Only with employer permission" },
        { id: "d", value: "(d) Only during training" },
      ],
      SIALicenceValid: [
        { id: "a", value: "(a) 1 year" },
        { id: "b", value: "(b) 2 years" },
        { id: "c", value: "(c) 3 years" },
        { id: "d", value: "(d) 5 years" },
      ],
      DoIfYouHaveLostYourLicence: [
        { id: "a", value: "(a) Report to the police and apply for a replacement from SIA" },
        { id: "b", value: "(b) Use non-front line license" },
        { id: "c", value: "(c) Continue working without it" },
        { id: "d", value: "(d) Wait for it to be found" },
      ],
      IfMoveAddress: [
        { id: "a", value: "(a) Employer & SIA" },
        { id: "b", value: "(b) Your family" },
        { id: "c", value: "(c) The police" },
        { id: "d", value: "(d) Nobody" },
      ],
      DoWithYourSIALicenceWhenYouAreAtWork: [
        { id: "a", value: "(a) Keep it in your wallet" },
        { id: "b", value: "(b) Display it visibly" },
        { id: "c", value: "(c) Hide it in your bag" },
        { id: "d", value: "(d) Leave it at home" },
      ],
      DoIfYouSeeAPersonAttemptToStealFromYourSite: [
        { id: "a", value: "(a) Confront them immediately" },
        { id: "b", value: "(b) Ignore them" },
        { id: "c", value: "(c) Prohibit them and report to supervisor or authorities" },
        { id: "d", value: "(d) Join them in stealing" },
      ],
      MainRoleAsASecurityOfficer: [
        { id: "a", value: "(a) Customer service" },
        { id: "b", value: "(b) Law enforcement" },
        { id: "c", value: "(c) Crime prevention" },
        { id: "d", value: "(d) Building maintenance" },
      ],
      HazardThatYouMightExpectToExperienceEveryDayAtWork: [
        { id: "a", value: "(a) Slippery floors" },
        { id: "b", value: "(b) Loud sound" },
        { id: "c", value: "(c) Bright lights" },
        { id: "d", value: "(d) Friendly colleagues" },
      ],
      DocumentInTheEventOfAnIncidentOnsite: [
        { id: "a", value: "(a) SOP and Assignment Instructions" },
        { id: "b", value: "(b) To capture incident" },
        { id: "c", value: "(c) Log" },
        { id: "d", value: "(d) Employee Handbook" },
      ],
    };
  },
  computed: {
    percentage() {
      return (this.correct / this.total * 100).toFixed(2);
    },
    result() {
      return this.percentage >= 60 ? 'Passed' : 'Fail';
    },
    questionsMeta() {
      return [
        { label: 'Can you carry out licensable activities without your SIA Licence badge?', options: this.LicenseAbleActivitiesWithoutYourSIALicenseBadge },
        { label: 'How long does an SIA Licence valid for?', options: this.SIALicenceValid },
        { label: 'What should you do if you have lost your licence?', options: this.DoIfYouHaveLostYourLicence },
        { label: 'Who should you tell if you move address?', options: this.IfMoveAddress },
        { label: 'What should you do with your SIA Licence when you are at work?', options: this.DoWithYourSIALicenceWhenYouAreAtWork },
        { label: 'What should you do if you see a person attempt to steal from your site?', options: this.DoIfYouSeeAPersonAttemptToStealFromYourSite },
        { label: 'What is your main role as a Security Officer?', options: this.MainRoleAsASecurityOfficer },
        { label: 'Write down a “Hazard” you might experience every day at work:', options: this.HazardThatYouMightExpectToExperienceEveryDayAtWork },
        { label: 'What do you call the document for site incidents?', options: this.DocumentInTheEventOfAnIncidentOnsite },
      ];
    },
    rules() {
      const r = {};
      for (let i = 1; i <= 10; i++) {
        r[`question_${i}`] = [{ required: true, message: 'This question is required', trigger: 'change' }];
      }
      return r;
    }
  },
  created(){
    this.$hub.$emit("candidateDetailActiveIndex", 6);

  },
  mounted() {
    this.populateData();
    this.calculateScore();
  },
  watch: {
    sia_Info: {
      handler() {
        this.populateData();
        this.calculateScore();
      },
      deep: true
    }
  },
  methods: {
    getRadioStatusClass(questionKey, optionId) {
      const answerObj = this.sia_Info.find(item => item.question === questionKey);

      // If we have verification data (marked) use correct/wrong classes
      if (answerObj && answerObj.verification) {
        if (optionId === answerObj.answer) {
          return answerObj.verification.correct ? 'correct-answer' : 'wrong-answer';
        }
        return '';
      }

      // If not marked yet, still highlight the selected answer for clarity/printing
      if (answerObj && optionId === answerObj.answer) {
        return 'selected-answer';
      }

      return '';
    },
    radioOnChange(question, value) {
      const index = this.sia_Info.findIndex(item => item.question === question);
      if (index === -1) this.sia_Info.push({ question, answer: value });
      else this.sia_Info[index].answer = value;
    },
    handleChange(questionKey) {
      const question = questionKey;
      const answer = this.siaInfoObj[question];
      const existingIndex = this.sia_Info.findIndex((item) => item.question === question);

      if (existingIndex === -1) {
        this.sia_Info.push({ question, answer });
      } else {
        this.sia_Info[existingIndex].answer = answer;
      }
    },
    populateData() {
      this.sia_Info.forEach((entry) => {
        if (entry.question) {
          this.$set(this.siaInfoObj, entry.question, entry.answer);
        }
      });
    },
    calculateScore() {
      this.sia_Info.forEach(val => {
        if (val?.verification) {
          if (val.verification.correct) this.correct++;
          else this.wrong++;
          this.total++;
        }
      });
      this.isMarked = this.total > 0;
    },
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.siaForm.validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            this.$toastr.e("Please answer all SIA questions.");
            reject(false);
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.bg-grey {
  background: grey;
  color: white;
}
.sia-questionnaire-form {
  max-width: 900px;
  margin: auto;
}
.correct-answer {
  background-color: #d4edda !important;
  border-radius: 4px;
  -webkit-print-color-adjust: exact;
}
.wrong-answer {
  background-color: #f8d7da !important;
  border-radius: 4px;
  -webkit-print-color-adjust: exact;
}
.selected-answer {
  background-color: #cfe2ff !important;
  border-radius: 4px;
  -webkit-print-color-adjust: exact;
}

@media print {
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    background-color: #fff !important;
    border-color: #000 !important;
    -webkit-print-color-adjust: exact;
  }

  ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
    background-color: #000 !important;
    width: 6px;
    height: 6px;
    -webkit-print-color-adjust: exact;
  }
}
</style>
